import { useCallback } from "react";

const useKaleidoImagePath = (subPath: string) => {
  const imagePath = useCallback((path: string) => `/image/lp/kaleido/${subPath}${path}`, [subPath]);
  return { imagePath };
};
export default useKaleidoImagePath;
